export const UNIT_OPTIONS = ['os.', 'sala', 'szt.', 'godz.', 'dni', 'kg', 'm', 'm²'] as const;
export type UnitOption = typeof UNIT_OPTIONS[number];
